import * as App from "@discovery/maestro/lib/app";
export * from "./parser-exception";
export const fromString = (s) => App.usingOf((r) => App.fromEither(r.json.fromString(s)));
export const toString = (s) => App.usingOf((r) => App.fromEither(r.json.toString(s)));

